export const ROUTES = {
  ROOT: "/",
  LOGIN: "/login",
  MAIN: "/main",
  FEES: "/fees",
  MORE: "/more",
  COVERAGE_ANALYSIS: "/coverage-analysis",
  OAUTH_CALLBACK: "/auth/callback/:provider",
  PRIVATE: "/private",
  EXAMPLE: "/example",
  // 회원가입 플로우 레이아웃 데모 (실제 구현 전 골격 확인용)
  SIGNUP_STEP_DEMO: "/signup/demo",
  SIGNUP_ONBOARDING_DEMO: "/signup/onboarding-demo",
  // 회원가입 플로우 실제 화면
  SIGNUP_TERMS: "/signup/terms",
  SIGNUP_IDENTITY: "/signup/identity",
  // 본인인증 완료 후 신용정보원 가입 여부 분기
  SIGNUP_CREDIT_REGISTER: "/signup/credit/register",
  SIGNUP_CREDIT_LOGIN: "/signup/credit/login",
  SIGNUP_CREDIT_FIND_ID: "/signup/credit/find-id",
  SIGNUP_CREDIT_RESET_PASSWORD: "/signup/credit/password-reset",
  // 신용정보원 비밀번호 90일 만료 시 진입하는 갱신 경량 화면(앱 내부, 인증 필요) — #149
  CREDIT_PASSWORD_RENEWAL: "/credit4u/renewal-pwd",
  // 신용정보원 비밀번호 desync 고착(OUT_OF_SYNC) 자력 복구용 세션 재설정 화면(앱 내부, 인증 필요) — #213
  CREDIT_PASSWORD_RESET: "/credit4u/password-reset",
  // 신용정보원 인증/가입 완료 후 진입하는 온보딩
  SIGNUP_ONBOARDING: "/signup/onboarding",
  // 외부 홈페이지 임시 리다이렉트 (정확히 /temp 만 매칭, 하위 경로 제외)
  TEMP: "/temp",
  // 이용약관/개인정보처리방침 — 무로그인 public 페이지(앱 심사 링크). 심사 URL: https://maketrend.co.kr/terms
  TERMS: "/terms",
  FEES_DETAIL: "/fees/detail/:id",       // 보험 상세 (L2). :id = 식별자 슬롯
  EXAM_HISTORY: "/more/exam-history",     // 시험내역 (L4)
  EXAM_HISTORY_DETAIL: "/more/exam-history/:id", // 시험 내역 상세 (L5)
  COMMISSION_LIFE: "/more/commission/life",        // 생보 수수료율 (L4)
  COMMISSION_NONLIFE: "/more/commission/non-life", // 손보 수수료율 (L4)
  COMMISSION_LIFE_SEARCH: "/more/commission/life/search",        // 생보 수수료율 검색 (#172)
  COMMISSION_NONLIFE_SEARCH: "/more/commission/non-life/search", // 손보 수수료율 검색 (#172)
  // 계정(프로필 관리 + 회원 탈퇴) — /account 네임스페이스 (#230)
  ACCOUNT: "/account",                             // 프로필 관리 (구 /profile, L1)
  ACCOUNT_WITHDRAW: "/account/withdraw",           // 회원 탈퇴 경고 화면 (#230 Spec 15)
  ACCOUNT_WITHDRAW_COMPLETE: "/account/withdraw/complete", // 회원 탈퇴 완료 화면 (#230 Spec 16)
  INVITE_CODE_REGISTER: "/invite-code/register",   // 초대 코드(추천인) 등록 (#91)
  ORGANIZATION: "/organization",                    // 조직 관리 (#93)
  // 조직관리 상세 (#372)
  ORGANIZATION_MEMBER_DETAIL: "/organization/:memberId",
  CONTRACT_HISTORY: "/contract-history",             // 계약 내역 (2차 더보기 「내 정보」, #348)
  COMMISSION_HISTORY: "/commission-history",         // 수수료 내역 (2차 더보기 「내 정보」, #348) — /more/commission/*(수수료율)과 구분
  // 수수료 내역 월별 상세 (#362)
  COMMISSION_HISTORY_MONTH: "/commission-history/:yearMonth",
  EXAM: "/exam",                                    // 시험 신청 폼 (정보입력~완료, #98) — 인트로/동의는 탭 오버레이
  EXAM_PAYMENT_RESULT: "/exam/payment/result",      // 카드 결제 return 302 도착 콜드스타트 결과페이지 (#276)
  PAYMENT_RETURN: "/payment/return",                // 간편결제 복귀(AOS 콜드 폴백·onEasyPayReturn 유도) 콜드스타트 폴링 (#282)
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];

export const routePath = {
  oauthCallback: (provider: string) => `/auth/callback/${provider}`,
  feesDetail: (id: string) => `/fees/detail/${id}`,
  examHistoryDetail: (id: number | string) => `/more/exam-history/${id}`,
  commissionHistoryMonth: (yearMonth: string) => `/commission-history/${yearMonth}`,
  organizationMemberDetail: (memberId: string) => `/organization/${memberId}`,
};
